import appConfig from 'appConfig';
import { getLogger } from '@cld/upload-widget-common';
import * as api from './api';
import * as common from './common';
import createTtlHandler from './ttlHandler';

const logger = getLogger();

const getWidgetBaseUrl = (newTlsDomain) => (newTlsDomain ? appConfig.api.widgetBaseNewTlsUrl : appConfig.api.widgetBase);

const getCloudInfo = (cloud, query, config) => {
  const infoApi = appConfig.api.info;
  const cloudInfoUrl = appConfig.api.cloudInfo || `${getWidgetBaseUrl(config.newTlsDomain)}${infoApi}/${cloud}.json`;

  logger.log(`[services.getCloudInfo]: about to retrieve cloud info for cloud: ${cloud}`);

  return api
    .get(cloudInfoUrl, query, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', // avoid preflight errors
      },
    })
    .catch((res) => {
      // only warn because server will return 400 if cloud name is incorrect or if cloud is disabled
      logger.warn(`[services.getCloudInfo]: encountered error when retrieving cloud (${cloud}) error: [${res.status}]: ${res.statusText}`);
    })
    .then((result) => {
      logger.log(`[services.getCloudInfo]: retrieved cloud info for ${cloud}: `, result);
      return result || {};
    });
};

export { getCloudInfo, api, common, createTtlHandler };
